import type { DrawItem } from "@/types/DrawItem";
import { ProjectEntityListSchema, type ProjectEntity } from "@/types/ProjectEntity";
import type { ProjectSettings } from "@/types/Projects";
import type { EntityRetainage } from "@/types/Retainage";

export const recalculateSourceOfFunds = async (
  entities: ProjectEntity[],
  items: DrawItem[],
  retainage: EntityRetainage[] | undefined,
  projectSettings: ProjectSettings,
  drawZero: boolean
) => {
  let recalcEntities: ProjectEntity[] = [];
  await axios
    .post("/project-entity/recalculate", {
      entities: entities,
      items: items,
      retainageList: retainage,
      projectSettings: projectSettings,
      drawZero: drawZero,
    })
    .then((response) => {
      recalcEntities = ProjectEntityListSchema.parse(response.data.result);
    })
    .catch((e) => errorApi(e));

  if (recalcEntities.length === 0) return entities;
  return recalcEntities;
};
